<div class="form-group">
  <label class="sa-form-label">
    {{title}}
    <span *ngIf="required != 'none'" style="color:red"> *</span>
  </label>
  <input id="{{id}}" type="number" class="form-control sa-formfield-input" [ngModel]="text" (ngModelChange)="change($event)" [ngClass]="text ? 'hasValue' : 'noValue'">
</div>
